// Same rules as the server's _merge3: keep fields the writer didn't touch,
// and for lists keep both sides' additions and deletions.
const keyOf = (field, x) => (field === "images" ? x : (x && (x.id || x.path || x.url)) || JSON.stringify(x));
const eq = (a, b) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);
const BLOCK_SPLIT = /(?<=<\/p>)|(?<=<\/div>)|(?<=<\/li>)|(?<=<\/h[1-6]>)|(?<=<\/blockquote>)|\n/;
const blocks = (s) => (s || "").split(BLOCK_SPLIT).filter((x) => x && x.trim());

// Both sides edited the body: keep `i` and add back paragraphs only `c` added.
export function mergeText(c, i, b) {
  const bb = new Set(blocks(b));
  const ib = new Set(blocks(i));
  return (i || "") + blocks(c).filter((x) => !bb.has(x) && !ib.has(x)).join("");
}

export function merge3(current, incoming, base) {
  const out = {};
  for (const [f, i] of Object.entries(incoming)) {
    if (!(f in base)) { out[f] = i; continue; }
    const b = base[f];
    const c = current?.[f];
    if (eq(i, b)) continue;
    if (eq(c, b) || c === undefined) { out[f] = i; continue; }
    if (Array.isArray(i) && Array.isArray(c) && Array.isArray(b)) {
      const bk = new Set(b.map((x) => keyOf(f, x)));
      const ck = new Set(c.map((x) => keyOf(f, x)));
      const ik = new Set(i.map((x) => keyOf(f, x)));
      out[f] = [
        ...i.filter((x) => !(bk.has(keyOf(f, x)) && !ck.has(keyOf(f, x)))),
        ...c.filter((x) => !bk.has(keyOf(f, x)) && !ik.has(keyOf(f, x))),
      ];
    } else if (f === "content" && typeof i === "string" && typeof c === "string") {
      out[f] = mergeText(c, i, typeof b === "string" ? b : "");
    } else out[f] = i;
  }
  return out;
}
